import { render, staticRenderFns } from "./PainSpotMain.vue?vue&type=template&id=0b59f61d&scoped=true"
import script from "./PainSpotMain.vue?vue&type=script&lang=js"
export * from "./PainSpotMain.vue?vue&type=script&lang=js"
import style0 from "./PainSpotMain.vue?vue&type=style&index=0&id=0b59f61d&prod&scoped=true&lang=css"
import style1 from "./PainSpotMain.vue?vue&type=style&index=1&id=0b59f61d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b59f61d",
  null
  
)

export default component.exports